import { render, staticRenderFns } from "./hgScan.vue?vue&type=template&id=00dc31b0&scoped=true"
import script from "./hgScan.vue?vue&type=script&lang=js"
export * from "./hgScan.vue?vue&type=script&lang=js"
import style0 from "./hgScan.vue?vue&type=style&index=0&id=00dc31b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc31b0",
  null
  
)

export default component.exports